import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 제휴문의 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 어떤 것이든 문의를 남겨주시면 연락드리겠습니다. ")
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 문의하기 ")

import axios from "axios";
import { ref } from "vue";
import { useDisplay } from "vuetify";
import { POSITION, useToast } from "vue-toastification";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { xs, smAndUp } = useDisplay();

const form = ref(null);
const valid = ref(true);
const data = ref({ name: "", phone: "", email: "", message: "" });

const commonRules = ref([
  (v: string) => !!v.replace(/\s/g, "") || "필수 입력 사항입니다.",
]);
const emailRules = ref([
  (v: string) =>
    /.+@.+\..+/.test(v.replace(/\s/g, "")) ||
    "이메일 형식이 올바르지 않습니다.",
]);

const reset = () => {
  if (!form.value) return;

  const formValue = form.value as { reset: () => any };
  formValue.reset();
};

const validate = async () => {
  if (!form.value) return;
  const formValue = form.value as { validate: () => any };
  const isValid = await formValue.validate();

  if (!isValid.valid) return;
  submitQA();
};

const sending = ref(false);
const toast = useToast();

const submitQA = () => {
  sending.value = true;

  const blocks = {
    attachments: [
      {
        color: "#6b96f3",
        blocks: [
          {
            type: "header",
            text: {
              type: "plain_text",
              text: "알츠톡 홍보 페이지에서 문의가 들어왔습니다.",
            },
          },
          {
            type: "divider",
          },
          {
            type: "section",
            fields: [
              {
                type: "mrkdwn",
                text: `*이름/회사 :*\n ${data.value.name.trim()}`,
              },
              {
                type: "mrkdwn",
                text: `*문의 남긴 날짜 :*\n ${new Date()}`,
              },
              {
                type: "mrkdwn",
                text: `*연락처 :*\n ${data.value.phone.trim()}`,
              },
              {
                type: "mrkdwn",
                text: `*이메일 :*\n ${data.value.email.trim()}`,
              },
            ],
          },
          {
            type: "section",
            text: {
              type: "mrkdwn",
              text: `*문의 내용:*\n ${data.value.message.trim()}`,
            },
          },
        ],
      },
    ],
  };
  axios
    .post(process.env.VUE_APP_SLACK_WEBHOOK_URL, JSON.stringify(blocks))
    .then(() => {
      toast.success("문의사항이 전달되었습니다.", {
        position: POSITION.TOP_CENTER,
        timeout: 2500,
      });
      reset();
      valid.value = true;
      sending.value = false;
    })
    .catch((error) => {
      console.log(error);
      toast.error("전달에 실패하였습니다", {
        position: POSITION.TOP_CENTER,
        timeout: 2500,
      });
      sending.value = false;
    });
};

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_spacer, {
      id: "inquiry",
      class: _normalizeClass({ 'py-2': _unref(xs), 'py-6': _unref(smAndUp) })
    }, null, 8, ["class"]),
    _createVNode(_component_v_container, { style: {"max-width":"1200px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: _normalizeClass(["py-8", { 'mx-2': _unref(xs), 'mx-16': _unref(smAndUp) }]),
          style: {"box-shadow":"2px 2px 10px 4px #00000060"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, {
              class: _normalizeClass(["font-weight-bold justify-center", { 'text-h5': _unref(xs) }]),
              style: {"font-size":"2.25rem"}
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_v_card_text, {
              class: _normalizeClass(["text-center pb-8", { 'text-subtitle-2': _unref(xs), 'text-subtitle-1': _unref(smAndUp) }])
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_v_form, {
              ref_key: "form",
              ref: form,
              modelValue: valid.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((valid).value = $event)),
              class: _normalizeClass({ 'text-body-2': _unref(xs) })
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { justify: "center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "11",
                      md: "5"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          ref: "nameField",
                          label: "이름/회사명",
                          variant: "outlined",
                          placeholder: "이름/회사명",
                          modelValue: data.value.name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.value.name) = $event)),
                          rules: commonRules.value
                        }, null, 8, ["modelValue", "rules"]),
                        _createVNode(_component_v_text_field, {
                          ref: "phoneField",
                          label: "연락처",
                          variant: "outlined",
                          placeholder: "01012345678",
                          modelValue: data.value.phone,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.value.phone) = $event)),
                          rules: commonRules.value
                        }, null, 8, ["modelValue", "rules"]),
                        _createVNode(_component_v_text_field, {
                          ref: "emailField",
                          label: "이메일",
                          variant: "outlined",
                          placeholder: "email@email.com",
                          modelValue: data.value.email,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.value.email) = $event)),
                          rules: commonRules.value.concat(emailRules.value)
                        }, null, 8, ["modelValue", "rules"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "11",
                      md: "5"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_textarea, {
                          ref: "messageArea",
                          name: "input-7-4",
                          label: "문의 내용",
                          variant: "outlined",
                          rows: "8",
                          "no-resize": "",
                          modelValue: data.value.message,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.value.message) = $event)),
                          rules: commonRules.value
                        }, null, 8, ["modelValue", "rules"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_3, [
                  (!sending.value)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (validate())),
                        class: _normalizeClass(["submit-button font-weight-medium text-white inquiryButton", { 'xs text-body-1': _unref(xs), 'text-h6': _unref(smAndUp) }]),
                        rounded: "pill"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : (_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        class: _normalizeClass(["inquiryButton", { xs: _unref(xs) }]),
                        rounded: "pill"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_progress_circular, {
                            indeterminate: "",
                            color: "grey-lighten-4"
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "class"])
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_spacer, {
      class: _normalizeClass({ 'py-2': _unref(xs), 'py-6': _unref(smAndUp) })
    }, null, 8, ["class"])
  ], 64))
}
}

})